export default __webpack_public_path__ + "static/des_illustration-e62a20f89966a39412fef4c668503cfd.svg";